module.exports = __webpack_public_path__ + "static/hawley-hex-gray-fdfbeb70adcfeb997d7620d66d5be9c0.png";